import { render, staticRenderFns } from "./wxzg.vue?vue&type=template&id=82056684&scoped=true&"
import script from "./wxzg.vue?vue&type=script&lang=js&"
export * from "./wxzg.vue?vue&type=script&lang=js&"
import style0 from "./wxzg.vue?vue&type=style&index=0&id=82056684&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82056684",
  null
  
)

export default component.exports